var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c(
      "div",
      {
        staticClass: "container feedback template-bg-gray",
        class: { "my-position-relative": _vm.isStatus }
      },
      [
        _vm.isStatus
          ? _c(
              "md-card",
              {
                staticClass:
                  "request-status loop_container bg-transparent update-request-form-common"
              },
              [
                _c(
                  "md-card-content",
                  {
                    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card form-wrapper text-center p-20" },
                      [
                        _c("h4", { staticClass: "template-custom-title" }, [
                          _vm._v(_vm._s(_vm.statusMsg))
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isStatus
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "loop_container bg-transparent update-request-form-common"
                    },
                    [
                      _c("div", { staticClass: "card form-wrapper" }, [
                        _c("div", { staticClass: "community-logo" }, [
                          _vm.$lodash.has(
                            _vm.community.customSettings,
                            "logoURL"
                          ) &&
                          _vm.community.customSettings &&
                          _vm.community.customSettings.logoURL
                            ? _c("img", {
                                staticClass: "top-logo custom-logo",
                                attrs: {
                                  src: _vm.community.customSettings.logoURL,
                                  alt:
                                    _vm.community &&
                                    _vm.community.content &&
                                    _vm.community.content.parameter2
                                      ? _vm.community.content.parameter2
                                      : "Community Logo"
                                }
                              })
                            : _vm.community.customSettings &&
                              !_vm.community.customSettings.logoURL
                            ? _c("img", {
                                staticClass: "top-logo custom-logo",
                                attrs: {
                                  src: _vm.logoURL,
                                  alt:
                                    _vm.community &&
                                    _vm.community.content &&
                                    _vm.community.content.parameter2
                                      ? _vm.community.content.parameter2
                                      : "Community Logo"
                                }
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-inline text-center footer-links" },
                    [
                      _c("li", [
                        _vm.community.content &&
                        _vm.community.content.landingPageURL &&
                        _vm.community.content.landingPageURL.length
                          ? _c(
                              "a",
                              {
                                staticClass: "links",
                                attrs: {
                                  href: _vm.community.content.landingPageURL,
                                  target: "_blank",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Learn More")]
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Learn More")]
                            )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm.community.content &&
                        _vm.community.content.termsConditionsURL &&
                        _vm.community.content.termsConditionsURL.length
                          ? _c(
                              "a",
                              {
                                staticClass: "links",
                                attrs: {
                                  href:
                                    _vm.community.content.termsConditionsURL,
                                  target: "_blank",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Terms Of Use [pdf]")]
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Terms Of Use [pdf]")]
                            )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm.community.content &&
                        _vm.community.content.unsubscribePageURL &&
                        _vm.community.content.unsubscribePageURL.length
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  tabindex: "0",
                                  href:
                                    _vm.community.content.unsubscribePageURL,
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Opt Out")]
                            )
                          : _c("a", { attrs: { href: "javascript:void(0)" } }, [
                              _vm._v("Opt Out")
                            ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "unsubscribe-community-logo email-actionpage-flogo"
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              (_vm.community.content &&
                                _vm.community.content.landingPageURL) ||
                              "https://www.protopia.co",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.logoURL, alt: "Community Logo" }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback_container" }, [
      _c(
        "div",
        { staticClass: "header-text text-center unsubscribepage-thankumsg" },
        [
          _c("h1", { staticClass: "template-title common-space-from-logo" }, [
            _vm._v("Thank you!")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cc37af6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc37af6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThankYou.vue
// module id = null
// module chunks = 